import axios from 'axios';
import ENDPOINTS from 'tradera-constants/endpoints';
import {
    utilizeCancelToken,
    finalizeResponse,
    handleError
} from 'tradera-utils/api';

export const fetchGeolocation = () => {
    const { cancel, cancelToken } = utilizeCancelToken('fetchGeolocation');

    if (cancel !== undefined) {
        cancel();
    }
    const search = (window && window.location && window.location.search) || '';
    return axios
        .get(getGeoPublicApiUrl(search), {
            cancelToken
        })
        .then(finalizeResponse())
        .catch(handleError());
};

export const getGeoPublicApiUrl = search => {
    const match = search.match(/force-geo-(.*?)-dev/);
    return !match
        ? ENDPOINTS.GEO_PUBLIC_API_URL
        : `${ENDPOINTS.GEO_PUBLIC_API_URL}/${match[1]}`;
};
